import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { Input } from "components";
import { ToggleButton } from "components/toggle";
import React from "react";

export const SharedMailboxSection = ({
  sharedMailboxData,
  setSharedMailboxData,
  error,
  buttonComponent,
}: {
  sharedMailboxData: {
    isSharedMailBox: boolean;
    sharedMailboxEmail: string | null;
  };
  error: string | null;
  buttonComponent: React.ReactNode;
  setSharedMailboxData: React.Dispatch<
    React.SetStateAction<{
      isSharedMailBox: boolean;
      sharedMailboxEmail: string | null;
    }>
  >;
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction={"row"}
      sx={{
        border: `1px solid ${theme.palette.neutral["015"]}`,
        borderRadius: "8px",
        p: "16px 24px",
        gap: "24px",
        // alignItems: "center",
        // justifyContent: "space-between",
        width: "100%",
      }}
    >
      <ToggleButton
        isChecked={sharedMailboxData.isSharedMailBox}
        onChange={(value: boolean) => {
          setSharedMailboxData({
            isSharedMailBox: value,
            sharedMailboxEmail: null,
          });
        }}
      />
      <Stack>
        <Typography variant="subtitle1">Use shared mailbox</Typography>
        <Typography variant="body-medium" color={theme.palette.lightBg.low}>
          Enable this if you are connecting an Office 365 shared mailbox.
        </Typography>
        {sharedMailboxData.isSharedMailBox && (
          <Stack sx={{ gap: "8px" }}>
            <Divider sx={{ my: "8px" }}></Divider>

            <Input
              label="Shared Mailbox Email"
              name="sharedmailbox"
              placeholder="sharedmailbox@domain.com"
              value={sharedMailboxData.sharedMailboxEmail}
              onChange={(e) => {
                setSharedMailboxData({
                  isSharedMailBox: sharedMailboxData.isSharedMailBox,
                  sharedMailboxEmail: e.target.value,
                });
              }}
              error={error ? true : false}
              errorMessage={error}
            />
            <Typography variant="body-small" color={theme.palette.lightBg.low}>
              Enter the shared mailbox email. Click Sign In and authenticate
              with an account that has delegation rights.
            </Typography>
            {buttonComponent}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
